import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface BadgeXPProps {
  className: string
  xp: number
}

export default function BadgeXP({ className = '', xp }: BadgeXPProps): React.ReactElement {
  const { t } = useTranslation('statistics')

  return (
    <div className={`border border-none rounded px-2 py-1 flex flex-row items-center justify-between ${className}`}>
      <ResponsiveImage alt={t('alt_texts.xp')} height={14} srcKey="scoreboard/xp.png" width={16} />
      <div className="text-xs text-center font-normal text-black-light ml-1">{xp}</div>
    </div>
  )
}
